<template>
  <div class="relative h-full text-sm">
    <h1 class="text-lg text-coal text-center font-bold">
      {{ lang === "mn" ? "Үйлчилгээний нөхцөл" : "Terms & Conditions" }}
    </h1>

    <div class="absolute bottom-0 bg-white w-full">
      <div
        class="flex w-full bg-grey p-3 rounded mb-14"
        :class="error ? 'border border-red-500' : ''"
      >
        <input
          type="checkbox"
          name="acceptTerm"
          id="acceptTerm"
          class="mr-2"
          v-model="isAccepted"
          @input="error = false"
        />
        <label for="acceptTerm" class="cursor-pointer">{{
          lang === "mn" ? "Үйлчилгээний нөхцөлийг хүлээн зөвшөөрч байна." : ""
        }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "YellowRegistrationStepThree",
  setup(_, { expose }) {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const isAccepted = ref(false);
    const error = ref(false);

    const validateForm = () => {
      let valid = true;

      if (!isAccepted.value) {
        error.value = true;
        valid = false;
      }

      return valid;
    };

    expose({ validateForm });

    return { lang, isAccepted, error };
  },
};
</script>
